<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      layout="vertical"
      finish-button-text="Modifier"
      back-button-text="Précédant"
      next-button-text="suivant"
      class="wizard-vertical mb-3"
      @on-complete="updateSupplier"
    >
      <!-- account datails tab -->
      <tab-content title="Fournisseur">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Fournisseur</h5>
            <small class="text-muted">
              Information général sur le Fournisseur.
            </small>
          </b-col>
          <b-col md="6">
            <b-form-group label="Nom" label-for="v-nom">
              <b-form-input
                id="v-nom"
                placeholder="Nom"
                v-model="supplier.firstName"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Prénom" label-for="v-prenom">
              <b-form-input
                id="v-prenom"
                placeholder="Prénom"
                v-model="supplier.lastName"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Email" label-for="v-email">
              <b-form-input
                id="v-email"
                placeholder="Email"
                v-model="supplier.email"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form
              ref="form"
              :style="{ height: trHeight + 150 }"
              class="repeater-form"
              @submit.prevent="repeateAgain"
            >
              <!-- Row Loop -->
              <b-row
                v-for="(item, index) in items"
                :id="item.id"
                :key="item.id"
                ref="row"
              >
                <!-- Item Name -->
                <b-col lg="9" md="9">
                  <b-form-group
                    label="Numéro de téléphone"
                    label-for="v-numero"
                  >
                    <b-form-input
                      id="v-numero"
                      placeholder="numero"
                      v-model="item.value"
                    />
                  </b-form-group>
                </b-col>
                <!-- Remove Button -->
                <b-col lg="1" md="1" class="mb-50">
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="mt-0 mt-md-2"
                    @click="removeItem(index)"
                  >
                    <feather-icon icon="XIcon" class="mr-25" />
                  </b-button>
                </b-col>
                <b-col lg="1" md="1" class="mb-50">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mt-0 mt-md-2"
                    @click="repeateAgain"
                  >
                    <feather-icon icon="PlusIcon" class="mr-25" />
                  </b-button>
                </b-col>
              </b-row>
              <!-- <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="repeateAgain"
              >
                <feather-icon icon="PlusIcon" class="mr-25" />
                <span>Ajouter un nouveau numéro</span>
              </b-button> -->
              <b-col cols="12">
                <hr />
              </b-col>
            </b-form>
          </b-col>
        </b-row>
      </tab-content>

      <!-- personal info tab -->
      <tab-content title="Adresse Fournisseur">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Adresse Fournisseur</h5>
            <small class="text-muted">Adresse du Fournisseur en détail</small>
          </b-col>
          <b-col md="8">
            <b-form-group label="Ville" label-for="v-ville">
              <b-form-input
                id="v-ville"
                placeholder="ville"
                v-model="supplier.city"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Code postal" label-for="v-cp">
              <b-form-input
                id="v-cp"
                placeholder="Code Postal"
                v-model="supplier.postalCode"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Adresse" label-for="v-adresse">
              <b-form-input
                id="v-adresse"
                placeholder="adresse"
                v-model="supplier.address"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { heightTransition } from "@core/mixins/ui/transition";
import VueBarcode from "vue-barcode";
import axios from "axios";
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  BImg,
  BRow,
  BCol,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormGroup,
  BFormFile,
  BFormInput,
  BFormTextarea,
  BForm,
  BButton,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BButton,
    BForm,
    VueBarcode,
    BImg,
    BFormFile,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormTextarea,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      items: [],
      nextTodoId: 2,
      optionCategorie: [],
      optionSubCategorie: [],
      supplier: {
        createdBy: JSON.parse(localStorage.getItem("userData"))._id,
        firstName: "",
        lastName: "",
        email: "",
        city: "",
        address: "",
        postalCode: "",
        telNumbers: [],
      },
    };
  },
  mounted() {
    axios
      .get(
        "https://management-projects.herokuapp.com/api/suppliers/" +
          this.$router.history.current.query.id
      )
      .then((response) => {
        response.data.telNumbers.forEach((element, index) => {
          this.items.push({ id: index + 1, value: element });
        });
        this.nextTodoId = response.data.telNumbers.length + 1;
        console.log("test", this.items, this.nextTodoId);
        this.supplier = response.data;
      })
      .catch((error) => {
        this.errorMessage = error.message;
      });

    setTimeout(this.initTrHeight(), 500);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  created() {
    window.addEventListener("load", this.initTrHeight);
  },
  methods: {
    repeateAgain() {
      this.items.push({
        id: (this.nextTodoId += this.nextTodoId),
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },

    updateSupplier() {
      this.supplier.telNumbers = [];
      this.items.forEach((element) => {
        this.supplier.telNumbers.push(element.value);
      });
      this.supplier.createdBy = this.supplier.createdBy._id;
      this.supplier.updatedBy = this.supplier.updatedBy._id;
      axios
        .put(
          "https://management-projects.herokuapp.com/api/suppliers/" +
            this.$router.history.current.query.id,
          this.supplier
        )
        .then((response) => {
          console.log(response);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Fournisseur bien modifié",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.$router.replace("/supplier");
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>
